import { adsPlatformCtaSelectOptions } from "@/lib/adsAssistantPlatformCtaOptions";

export function AdsAssistantPlatformCtaField(props: {
  platform: string;
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}) {
  const { platform, value, onChange, disabled } = props;
  const opts = adsPlatformCtaSelectOptions(platform);
  return (
    <label className="block text-[11px] text-gray-600 dark:text-gray-400 sm:col-span-2">
      Platform CTA (when the ad used a button not visible in pasted text)
      <select
        className="mt-0.5 w-full max-w-md rounded border border-gray-200 bg-white px-2 py-1.5 text-sm dark:border-gray-600 dark:bg-zinc-950 dark:text-gray-100"
        value={opts.some((o) => o.value === value) ? value : ""}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {opts.map((o) => (
          <option key={o.value || "__empty"} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
